<template>
    <div class="k-loading-mask" style="width:100%;height:100%"><span class="k-loading-text">Loading...</span><div class="k-loading-image"><div class="k-loading-color"></div></div></div>
</template>

<script>
export default {
  name: "loader"
}
</script>
<style lang="scss" scoped>
.k-loading-mask {
    z-index: 9999999;
}
.k-loading-color {
    opacity: .5;
    cursor: not-allowed;
}
.smallLoader{
    cursor: progress;
 .k-loading-image{

     width: 40px  !important;
    right: 0;
    left: auto  !important;
    &:lang(ar){
        right: auto;
    left: 0  !important;
    }
    background: #dee3e8  !important;
   &::before,&::after{
       font-size: 1.5em;
    }
       }
    &.withoutLabel{
        .k-loading-image{

            right: 15px;
            &:lang(ar){
                left: 15px  !important;
            }
            }
    }
}
</style>
